// extracted by mini-css-extract-plugin
module.exports = {"layout":"video-testimonial_layout__obVtR","videoContainer":"video-testimonial_videoContainer__zfVWC"};